import { createContext, useContext, useState, useEffect } from 'react';
import api from 'services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('gss_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('gss_token');
    const saved = localStorage.getItem('gss_user');
    if (token && saved) {
      setUser(JSON.parse(saved));
      api.get('/auth/me').then(res => {
        setUser(res.data);
        localStorage.setItem('gss_user', JSON.stringify(res.data));
      }).catch(() => {
        logout();
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password, turnstileToken) => {
    const res = await api.post('/auth/login', { email, password, turnstileToken });
    const { user: u, token } = res.data;
    localStorage.setItem('gss_token', token);
    localStorage.setItem('gss_user', JSON.stringify(u));
    setToken(token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('gss_token');
    localStorage.removeItem('gss_user');
    setToken(null);
    setUser(null);
  };

  const updateUser = (patch) => {
    const updated = { ...user, ...patch };
    setUser(updated);
    localStorage.setItem('gss_user', JSON.stringify(updated));
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
